import { render } from "./LoginBox.vue?vue&type=template&id=d168c86c&scoped=true"
import script from "./LoginBox.vue?vue&type=script&lang=js"
export * from "./LoginBox.vue?vue&type=script&lang=js"

import "./LoginBox.vue?vue&type=style&index=0&id=d168c86c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d168c86c"]])

export default __exports__